import { useCallback } from "react";
import { generateMockMatterLitigationDatePayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterLitigationDate } from "@/lib/data/react-query/matters/matter-litigation-date";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterLitigationDate = () => {
  const createLitigationDate = useCreateMatterLitigationDate();

  const createMockMatterLitigationDate = useCallback(
    async (
      matterId: string,
      id: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createLitigationDate.mutateAsync(
          generateMockMatterLitigationDatePayload(matterId, id, overrides),
        ),
      ),
    [createLitigationDate],
  );

  return {
    createMockMatterLitigationDate,
    mutation: createLitigationDate,
  };
};
